module.exports = __webpack_public_path__ + "img/wxewm.73c75a57.png";